import { type MouseEventHandler } from "react";
import { IconType } from "~/common/components/icon/IconType";
import { Button } from "~/common/mui";
import { Icon } from "~/common/components/icon/Icon";
import { useTranslation } from "react-i18next";
import { STORE_FINDER } from "~/utils/url/staticUrls";

interface ButtonProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLElement>;
  href?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const AddToCartButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  const disabled = window.SCHA.config.disableAllWS || props.disabled == null ? false : props.disabled;
  return (
    <Button startIcon={<Icon type={IconType.Cart} />} data-test-id={"btn-add-to-cart"} disabled={disabled} {...props}>
      {t("page.wishlist.action.addSelected")}
    </Button>
  );
};

interface RequestOfferButtonProps {
  selectedEntryIds: string[];
  wishlistId: string;
}
export const RequestOfferButton = (props: ButtonProps & RequestOfferButtonProps) => {
  const { t } = useTranslation();
  const { wishlistId, selectedEntryIds } = props;
  const params = new URLSearchParams();
  params.set("wl-id", wishlistId);
  params.set("wl-entry-ids", selectedEntryIds.join(","));

  return (
    <Button
      href={STORE_FINDER + "?" + params.toString()}
      data-test-id={"btn-request-offer"}
      disabled={selectedEntryIds.length === 0}
      {...props}
    >
      {t("page.wishlist.button.requestOffer")}
    </Button>
  );
};
